import { RECIPES } from "./actions";
import Constants from "../constants";

const MUTATION = {
  SET_QUERY: "SET_QUERY",
  SET_VIEW_TYPE: "SET_VIEW_TYPE",
  SET_SORT: "SET_SORT",
  SET_RECIPES_COUNT: "SET_RECIPES_COUNT",
  SET_PAGE_NUM: "SET_PAGE_NUM",
  SET_PAGE_PREV: "SET_PAGE_PREV",
  SET_PAGE_NEXT: "SET_PAGE_NEXT",
  SET_PAGE_SIZE: "SET_PAGE_SIZE",
  SET_WITH_IMAGES_ONLY: "SET_WITH_IMAGES_ONLY",
  SET_CATEGORY_FILTER: "SET_CATEGORY_FILTER"
};

const defaultSort = { column: "name", direction: "ASC" };

export default {
  namespaced: true,
  state: {
    query: null,
    view: Constants.viewType.GRID,
    columns: [
      { label: "Name", field: "name", width: "52%" },
      { label: "Prep Time", field: "prepTime", width: "12%" },
      { label: "Cook Time", field: "cookTime", width: "12%" },
      { label: "Servings", field: "servings", width: "12%" },
      { label: "Date", field: "updatedAt", width: "12%" }
    ],
    sort: defaultSort,
    defaultSort,
    count: null,
    pageNum: 1,
    pageSize: 48,
    withImagesOnly: false,
    filterByCategory: {
      categoryKey: Constants.categories.ALL_CATEGORIES_KEY,
      categoryName: Constants.categories.ALL_CATEGORIES_NAME
    }
  },
  mutations: {
    [MUTATION.SET_QUERY](state, query) {
      state.query = query;
    },
    [MUTATION.SET_VIEW_TYPE](state, type) {
      state.view = type;
    },
    [MUTATION.SET_SORT](state, sortObj) {
      if (state.sort.column !== sortObj.column || state.sort.direction !== sortObj.direction) {
        // reset pagination
        state.pageNum = 1;
      }

      state.sort = {
        column: sortObj.column,
        direction: sortObj.direction
      }
    },
    [MUTATION.SET_RECIPES_COUNT](state, count) {
      if(state.count !== count) {
        // reset pagination
        state.pageNum = 1;
      }

      state.count = count;
    },
    [MUTATION.SET_PAGE_NUM](state, pageNum) {
      state.pageNum = pageNum;
    },
    [MUTATION.SET_PAGE_PREV](state) {
      state.pageNum = state.pageNum - 1;
    },
    [MUTATION.SET_PAGE_NEXT](state) {
      state.pageNum = state.pageNum + 1;
    },
    [MUTATION.SET_PAGE_SIZE](state, pageSize) {
      state.pageSize = pageSize;
    },
    [MUTATION.SET_WITH_IMAGES_ONLY](state, checked) {
      state.withImagesOnly = checked;
    },
    [MUTATION.SET_CATEGORY_FILTER](state, category) {
      state.filterByCategory = category;
    }
  },
  actions: {
    [RECIPES.SET_QUERY]({ commit }, query) {
      commit(MUTATION.SET_QUERY, query);
    },
    [RECIPES.SET_VIEW_TYPE]({ commit }, type) {
      commit(MUTATION.SET_VIEW_TYPE, type);
    },
    [RECIPES.SET_SORT]({ commit }, sortObj) {
      commit(MUTATION.SET_SORT, sortObj);
    },
    [RECIPES.SET_RECIPES_COUNT]({ commit }, count) {
      commit(MUTATION.SET_RECIPES_COUNT, count);
    },
    [RECIPES.SET_PAGE_NUM]({ commit }, pageNum) {
      commit(MUTATION.SET_PAGE_NUM, pageNum);
    },
    [RECIPES.SET_PAGE_PREV]({ commit }) {
      commit(MUTATION.SET_PAGE_PREV);
    },
    [RECIPES.SET_PAGE_NEXT]({ commit }) {
      commit(MUTATION.SET_PAGE_NEXT);
    },
    [RECIPES.SET_PAGE_SIZE]({ commit }, pageSize) {
      commit(MUTATION.SET_PAGE_SIZE, pageSize);
    },
    [RECIPES.SET_WITH_IMAGES_ONLY]({ commit }, checked) {
      commit(MUTATION.SET_WITH_IMAGES_ONLY, checked);
    },
    [RECIPES.SET_CATEGORY_FILTER]({ commit }, category) {
      commit(MUTATION.SET_CATEGORY_FILTER, category);
    }
  }
};
